export const TEST_IDS = {
  ROOT: 'media-carousel',
} as const;
